import React from 'react'
import { twMerge } from 'tailwind-merge'
import './index.css'

const Loading: React.FC<PropType> = ({ text, className }) => {
  const classNames = twMerge('flex flex-col h-full w-full items-center justify-center', className)
  return (
    <div className={classNames}>
      <div className="loader"></div>
      {text && <div>{text}</div>}
    </div>
  )
}

interface PropType {
  text?: string
  className?: string
}

export default Loading
